// export DsfScheduleList from "./scheduleList.vue";
export const DsfScheduleList = dsf.defineAsyncComponent("DsfScheduleList", () => import(/*webpackChunkName:"platform_pc_homepage"*/ "./scheduleList.vue"));
export const DsfScheduleListSetting = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_pc_output_common" */ "./scheduleListSetting"));
